module.exports = __webpack_public_path__ + "img/dinein.66be54db.svg";